module.exports = __webpack_public_path__ + "static/workout-app-cover-d2931a071e7d85b0ae3aa73cbf77783a.png";